import { ChangeEvent, FormEvent, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { CompanyCreate } from "../../models/Companies/CompanyCreate";

interface Props {
  closeForm: () => void;
  create: (company: CompanyCreate) => void;
}

export default function CreateCompanyForm({ closeForm, create }: Props) {
  const [companyData, setCompanyData] = useState<CompanyCreate>({
    companyName: "",
    companyDomain: "",
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    create(companyData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setCompanyData({ ...companyData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Company Name"
        name="companyName"
        value={companyData.companyName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Company Domain Name"
        name="companyDomain"
        value={companyData.companyDomain}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Create
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
